import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { AiFillCaretUp } from "react-icons/ai";
import { DateFormat, SurveyStartDate, SurveyEndDate } from "../common/DateFormat";

const SurveyDescription = ({ IntroductionText, surveyDetails, surveyDescription }) => {
  const [description, setDescription] = useState(true);
  return (
    <>

    <div className="header_bottom_sticky">
      {/* <div className={"survey-description " + `${description ? "show" : "hide"}`}> */}
      <div className={description ? "survey-description show" : "survey-description hide"}>
        <Container fluid>
          <Row>
            <Col xl={10} lg={10} md={10} sm={10} xs={10}>
              <div className="survey-timings">
                <p>
                  <>
                  <div className="start_d">
                    <SurveyStartDate start_date={surveyDetails.StartDate} />
                  </div>

                  <div className="end_d">
                    <SurveyEndDate end_date={surveyDetails.ExpiryDate} />
                  </div>
                  </>
                </p>
              </div>
            </Col>
            

            <Col xl={2} lg={2} md={2} sm={2} xs={2}>
              <div
                className={`surveyStatus ms-3 float-end ${
                  surveyDetails.SurveyStatus === "Closed" ? "active bg-danger" : "active bg-success"
                }`}>
                <span></span>
                {surveyDetails.SurveyStatus == "Closed" ? "Closed" : "Active"}
              </div>
              <div className="clearfix"></div>
            </Col>

              {surveyDescription != ""?(
                <>
                <Col lg={12}>
                    <p>{surveyDescription}</p>
                </Col>
                </>
              ):(
                <></>
              )}
           
          </Row>
        </Container>
      </div>
      <div className={`survey-toggle ${description ? "" : "rotate"}`} onClick={() => setDescription(!description)}>
        <AiFillCaretUp />
      </div>
    </div>
    </>
  );
};

export default SurveyDescription;
